/* unplugin-vue-components disabled */import script from "./AiPredictionView.vue?vue&type=script&setup=true&lang=js"
export * from "./AiPredictionView.vue?vue&type=script&setup=true&lang=js"

import "./AiPredictionView.vue?vue&type=style&index=0&id=0b64d585&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b64d585"]])

export default __exports__